
import { Card, CardHeader, CardTitle, CardDescription } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { ExternalLink } from "lucide-react";
import { IntegrationsMenu } from "./IntegrationsMenu";

export const ChevronHeader = () => {
  return (
    <div className="flex items-center gap-6 justify-between">
      <div className="flex items-center gap-6">
        <img 
          src="/lovable-uploads/8a556e19-9fef-436f-b2a4-9b96b85aaec9.png" 
          alt="Chevron Logo" 
          className="w-24 h-24 object-contain"
        />
        <div>
          <CardTitle className="text-2xl font-bold mb-2">Chevron Corporation</CardTitle>
          <CardDescription className="text-lg">
            Higher Returns. Lower Carbon.
          </CardDescription>
          <Button 
            variant="link" 
            className="p-0 h-auto text-primary hover:text-primary/80 flex items-center gap-2"
            onClick={() => window.open('https://www.chevron.com/', '_blank')}
          >
            Visit Chevron Website
            <ExternalLink className="h-4 w-4" />
          </Button>
        </div>
      </div>
      <IntegrationsMenu />
    </div>
  );
};
